import { AuthTokenCookie } from "@/enums/auth-token-cookie.enum";
import { browserCookie } from "@/utils/browserCookie";

export const getAccessTokenFromCookie = (): string =>
  browserCookie.get(AuthTokenCookie.Access) ?? "";
